import {
  createColumn,
  getCommonBodyCellPropsTradesPositions,
  getCommonHeadCellProps,
  getCommonFooterCellProps,
  getEcdStatusCellProps,
  renderEcdStatus,
  getEcdStatusSortPriority, // Add this import
} from "./commonUtils";

export const getEcdEzeScrubColumns = (theme, globalFilter) => {
  const commonHeadCellProps = getCommonHeadCellProps(theme);
  const commonBodyCellProps = getCommonBodyCellPropsTradesPositions(theme);
  const commonFooterCellProps = getCommonFooterCellProps(theme);
  const ecdStatusCellProps = getEcdStatusCellProps(theme);

  const highlightMatch = (text, searchTerm) => {
    if (!searchTerm || !text) return text;
    const textStr = String(text);
    const searchStr = String(searchTerm);
    const regex = new RegExp(`(${searchStr})`, "gi");
    const parts = textStr.split(regex);
    return parts?.map((part, index) =>
      part.toLowerCase() === searchStr.toLowerCase() ? (
        <span
          key={index}
          style={{
            backgroundColor: theme.palette.warning.light,
            color: theme.palette.warning.contrastText,
            padding: "1px 2px",
            borderRadius: theme.shape.borderRadius * 0.5,
          }}
        >
          {part}
        </span>
      ) : (
        part
      ),
    );
  };

  // Helper function to format dates
  const formatDate = (dateValue) => {
    if (!dateValue || dateValue === "-") return "-";
    
    try {
      const date = new Date(dateValue);
      if (isNaN(date.getTime())) return dateValue; // Return original if invalid date
      
      return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD
    } catch (error) {
      return dateValue; // Return original if parsing fails
    }
  };

  return [
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "eze_geneva_alias",
      "Eze Geneva Alias",
      "25%",
      "left",
      {
        body: {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        other: {
          enableGrouping: true,
          Cell: ({ cell }) =>
            highlightMatch(cell.getValue() || "-", globalFilter),
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "eze_ecd",
      "Eze ECD Date",
      "20%",
      "left",
      {
        body: {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        other: {
          enableGrouping: true,
          Cell: ({ cell }) => {
            const formattedDate = formatDate(cell.getValue());
            return highlightMatch(formattedDate, globalFilter);
          },
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "eze_ecd_assigned",
      "Imported Eze ECD Date",
      "30%",
      "left",
      {
        body: {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        other: {
          enableGrouping: true,
          Cell: ({ cell }) => {
            const formattedDate = formatDate(cell.getValue());
            return highlightMatch(formattedDate, globalFilter);
          },
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      ecdStatusCellProps,
      commonFooterCellProps,
      "eze_ecd_flag",
      "ECD Status",
      "25%",
      "center",
      {
        body: {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        other: {
          enableGrouping: true,
          // Remove accessorFn and use sortingFn with a custom function
          sortingFn: (rowA, rowB, columnId) => {
            const a = rowA.getValue(columnId);
            const b = rowB.getValue(columnId);
            
            const priorityA = getEcdStatusSortPriority(a);
            const priorityB = getEcdStatusSortPriority(b);
            
            return priorityA - priorityB;
          },
          Cell: ({ cell }) => {
            const status = cell.getValue();
            if (!status || status === "-") return "-";
            
            return renderEcdStatus(status, theme);
          },
        },
      },
    ),
  ];
};

